module.exports = __webpack_public_path__ + "img/Postmodernisme_Jan-Erik-Vold.aaa3280a.jpg";